import { useEffect } from "react";

const ABSOLUTE = (path = "") => {
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${path}`;
};

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(url) {
  if (!url) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

/**
 * useSeo({ title, description, image, url, type })
 * Updates <title>, meta description, Open Graph & Twitter card per route.
 */
export function useSeo({ title, description, image, url, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Gemma Veda` : "Gemma Veda — Author of the Soul's CODE Series";
    const desc = description || "Gemma Veda — new-age author. Stories drawn from experience, culture and ancient wisdom. The Soul's CODE series and ongoing journal.";
    const finalUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const finalImage = image ? (image.startsWith("http") ? image : ABSOLUTE(image)) : ABSOLUTE("/og-default.jpg");

    document.title = fullTitle;
    setMeta("description", desc);

    // Open Graph
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", type, "property");
    setMeta("og:url", finalUrl, "property");
    setMeta("og:image", finalImage, "property");
    setMeta("og:site_name", "Gemma Veda", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", finalImage);

    setCanonical(finalUrl);
  }, [title, description, image, url, type]);
}
